import { useTranslation } from "react-i18next";
import { twMerge } from "tailwind-merge";
import { Badge } from "@components/Badge/Badge";
import { Button } from "@components/Button";
import {
  AddBillMethod,
  type IAddBillVariantMethodButtonProps,
} from "../AddBillVariantSelectorModalTypes";

export const AddBillVariantMethodButtonPL: React.FC<
  IAddBillVariantMethodButtonProps
> = (props) => {
  const { badgeIcon, badgeColor, variant, onClick, className } = props;

  const { t } = useTranslation();

  return (
    <div
      className={twMerge(
        "flex items-center gap-4 rounded-2xl border border-grey-light p-6 text-left",
        className,
      )}
      style={{ top: "0px" }}
    >
      <Badge
        icon={badgeIcon}
        variant="rounded"
        size="large"
        color={badgeColor}
      />
      <div className="flex flex-col gap-1">
        <span className="text-sm font-semibold">
          {t(`addBillVariantSelectorModal.methods.${variant}.title`)}
        </span>
        <span className="text-sm text-grey-dark">
          {t(`addBillVariantSelectorModal.methods.${variant}.description`)}
        </span>
      </div>
      <div className="flex flex-grow justify-end">
        <Button
          className="min-w-36"
          onClick={onClick}
          variant={variant === AddBillMethod.PDF ? "primary" : "secondary"}
        >
          {t(`addBillVariantSelectorModal.methods.${variant}.button`)}
        </Button>
      </div>
    </div>
  );
};
